import styles from "./scanButton.module.scss";

export default function ScanButton({ inverted = false, red = false }) {
  const handleClick = () => {
    window.open(`${window.location.origin}/ar/index.html`);
  };
  return (
    <div className={styles.buttonContainer}>
      <div
        className={[
          styles.scanButtonBg,
          inverted && styles.scanButtonBgInverted,
        ]
          .filter(Boolean)
          .join(" ")}
      ></div>
      <button
        onClick={handleClick}
        className={[styles.scanButton, inverted && styles.scanButtonInverted, red && styles.scanButtonRed]
          .filter(Boolean)
          .join(" ")}
      >
        SCAN NOW
      </button>
    </div>
  );
}
